import { create } from 'zustand';

/**
 * Bildirim kuyruğu.
 * Prototipte tek bir `toastMessage` state'i vardı: ikinci bildirim birincinin
 * zamanlayıcısını iptal etmeden üzerine yazıyordu.
 */

export type ToastKind = 'success' | 'error' | 'info';

/**
 * Bildirimin üzerindeki tek eylem.
 *
 * "Geri al" için eklendi. Bir geri alma düğmesinin doğru yeri, işlemin
 * sonucunu bildiren bildirimin ta kendisidir: kullanıcı zaten oraya bakıyor ve
 * pişmanlık tam o anda oluşuyor. Ayrı bir kutu ya da sayfa, geri almayı
 * "bulunması gereken" bir şeye çevirirdi.
 */
export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface Toast {
  id: string;
  kind: ToastKind;
  text: string;
  action?: ToastAction;
}

export interface ToastOptions {
  action?: ToastAction;
  /** Varsayılanı aşan süre — eylemli bildirimler okunup tıklanacak kadar durmalı. */
  durationMs?: number;
}

interface ToastState {
  toasts: Toast[];
  push: (kind: ToastKind, text: string, options?: ToastOptions) => void;
  dismiss: (id: string) => void;
}

const AUTO_DISMISS_MS = 5000;
const MAX_VISIBLE = 3;

export const useToastStore = create<ToastState>()((set) => ({
  toasts: [],

  push: (kind, text, options) => {
    const id = crypto.randomUUID();
    const entry: Toast = {
      id,
      kind,
      text,
      ...(options?.action === undefined ? {} : { action: options.action }),
    };
    set((s) => ({ toasts: [...s.toasts, entry].slice(-MAX_VISIBLE) }));
    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
    }, options?.durationMs ?? AUTO_DISMISS_MS);
  },

  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

/** Bileşen dışından da çağrılabilsin diye (mutation onError vb.). */
export const toast = {
  success: (text: string, options?: ToastOptions) =>
    useToastStore.getState().push('success', text, options),
  error: (text: string, options?: ToastOptions) =>
    useToastStore.getState().push('error', text, options),
  info: (text: string, options?: ToastOptions) =>
    useToastStore.getState().push('info', text, options),
};
